import { Link } from "react-router-dom";
import { getRelatedBlogPosts } from "../lib/blog";

export function RelatedArticles({ exclude }: { exclude: string }) {
  const related = getRelatedBlogPosts(exclude, 2).map((article) => ({
    slug: article.href,
    title: article.title,
    description: article.description,
    tag: article.category,
  }));

  return (
    <section className="border-t border-slate-200 bg-slate-50 py-14 sm:py-16">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <p className="text-sm font-semibold uppercase tracking-[0.24em] text-sky-700">
          Continue reading
        </p>
        <h2 className="mt-4 text-3xl font-semibold tracking-tight text-slate-950 sm:text-4xl">
          Related articles
        </h2>
        <div className="mt-8 grid gap-4 sm:grid-cols-2">
          {related.map((article) => (
            <Link
              key={article.slug}
              to={article.slug}
              className="group rounded-md border border-slate-200 bg-white p-5 transition hover:-translate-y-0.5 hover:shadow-lg hover:shadow-slate-200/60"
            >
              <span className="rounded-md bg-sky-50 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-sky-700">
                {article.tag}
              </span>
              <h3 className="mt-3 text-lg font-semibold text-slate-950 transition group-hover:text-sky-700">
                {article.title}
              </h3>
              <p className="mt-2 text-sm leading-6 text-slate-600">
                {article.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}